export enum Onboardingstatus {
    REJECTED = "Rejected",
    PENDING = "Pending",
    STARTED = "Started",
    APPROVED = "Approved",
    SUBMITTED = "Submitted",
    COMPLETED = "Completed",
    OFFBOARDING = "Offboarding",
    TERMINATED = "Terminated"
}
